module.exports = __webpack_public_path__ + "img/1740018442298-WhatsApp Image 2025-02-20 at 10.25.57.jpeg.1b1bd7a6.webp";